<header class="header">
  <div class="header-left">
    <a routerLink="/" class="header-logo"> </a>
  </div>
  <div class="header-right">
    <div class="header-right-top">
      <div class="header-media">
        <a
          href="https://twitter.com/wallofshamenft"
          target="_blank"
          class="header-media--item"
        >
          <svg
            class="header-icon"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27.9179 9.98121C27.9377 10.2443 27.9377 10.506 27.9377 10.7676C27.9377 18.7741 21.7506 28 10.4433 28C6.9597 28 3.72339 27.0061 1 25.28C1.49461 25.3357 1.97089 25.3552 2.48535 25.3552C5.35986 25.3552 8.00539 24.3989 10.1197 22.7676C7.41614 22.7119 5.15072 20.9678 4.36912 18.5681C4.74924 18.6237 5.13088 18.6613 5.53084 18.6613C6.08192 18.6613 6.63607 18.5861 7.15052 18.4553C4.33096 17.893 2.21972 15.4557 2.21972 12.5117V12.4365C3.03949 12.8861 3.99054 13.1673 4.99807 13.2049C3.34175 12.1193 2.25636 10.2624 2.25636 8.16188C2.25636 7.03721 2.56015 6.00576 3.09292 5.10663C6.12009 8.77985 10.6708 11.1811 15.7725 11.4442C15.6779 10.9931 15.6199 10.5255 15.6199 10.0564C15.6199 6.71846 18.3616 4 21.7689 4C23.5397 4 25.138 4.73074 26.2616 5.91254C27.6507 5.64942 28.9819 5.14271 30.1634 4.44957C29.707 5.85541 28.7346 7.03721 27.4599 7.7875C28.6979 7.65518 29.8978 7.31838 31 6.84927C30.1634 8.04912 29.1177 9.11816 27.9179 9.98121Z"
            />
          </svg>
        </a>
        <a href="mailto:wallofshamenft@gmail.com" class="header-media--item">
          <svg
            class="header-icon"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.0169 5H6.98305C5.66185 5.00125 4.39512 5.52223 3.46089 6.44861C2.52666 7.37499 2.00126 8.63108 2 9.94118L2 24.0588C2.00126 25.3689 2.52666 26.625 3.46089 27.5514C4.39512 28.4778 5.66185 28.9988 6.98305 29H25.0169C26.3382 28.9988 27.6049 28.4778 28.5391 27.5514C29.4733 26.625 29.9987 25.3689 30 24.0588V9.94118C29.9987 8.63108 29.4733 7.37499 28.5391 6.44861C27.6049 5.52223 26.3382 5.00125 25.0169 5V5ZM26.5498 13.1459L18.0359 17.8941C17.4129 18.2365 16.7123 18.4161 16 18.4161C15.2877 18.4161 14.5871 18.2365 13.9641 17.8941L5.45017 13.1459C5.29517 13.0816 5.15571 12.9853 5.04102 12.8636C4.92634 12.7418 4.83905 12.5972 4.78493 12.4395C4.73082 12.2818 4.7111 12.1144 4.7271 11.9486C4.7431 11.7827 4.79445 11.6221 4.87774 11.4774C4.96103 11.3327 5.07437 11.2072 5.21026 11.1092C5.34614 11.0112 5.50147 10.9429 5.66596 10.9089C5.83045 10.8749 6.00035 10.8759 6.16441 10.9119C6.32847 10.9479 6.48295 11.018 6.61763 11.1176L15.1268 15.8235C15.3936 15.9715 15.6943 16.0492 16 16.0492C16.3057 16.0492 16.6064 15.9715 16.8732 15.8235L25.3824 11.1176C25.5182 11.0356 25.6693 10.9816 25.8266 10.9586C25.9839 10.9356 26.1443 10.9443 26.2982 10.984C26.4521 11.0237 26.5963 11.0937 26.7224 11.1898C26.8485 11.2859 26.9538 11.4062 27.0321 11.5434C27.1104 11.6807 27.16 11.8321 27.1781 11.9888C27.1962 12.1455 27.1823 12.3041 27.1373 12.4554C27.0923 12.6066 27.0171 12.7473 26.9162 12.8692C26.8153 12.991 26.6907 13.0915 26.5498 13.1647V13.1459Z"
            />
          </svg>
        </a>
      </div>
      <div class="header-navigation">
        <a class="header-navigation--item" (click)="openHowToPopup()">How To</a>
        <a class="header-navigation--item cart" routerLink="cart">
          <svg
            class="header-icon"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.00006 4C5.46961 4 4.96089 4.19832 4.5858 4.55132C4.21073 4.90434 4 5.38312 4 5.88235C4 6.38159 4.21073 6.86037 4.5858 7.21338C4.96089 7.56638 5.46961 7.76471 6.00006 7.76471H8.44014L9.05016 10.0649C9.05622 10.0914 9.06288 10.1178 9.07016 10.144L11.7862 20.3652L10.0002 22.0442C7.48011 24.416 9.26416 28.4706 12.8283 28.4706H30.0008C30.5312 28.4706 31.04 28.2722 31.4151 27.9192C31.7901 27.5663 32.0009 27.0874 32.0009 26.5882C32.0009 26.089 31.7901 25.6102 31.4151 25.2572C31.04 24.9043 30.5312 24.7059 30.0008 24.7059H12.8283L14.8283 22.8235H28.0008C28.3722 22.8233 28.736 22.7258 29.0518 22.5419C29.3676 22.3582 29.6228 22.0952 29.7888 21.7826L35.789 10.4885C35.9414 10.2016 36.0132 9.88277 35.998 9.56237C35.9826 9.24196 35.8806 8.93054 35.7014 8.65768C35.5222 8.38483 35.272 8.15957 34.9744 8.00327C34.6768 7.847 34.3417 7.76488 34.0009 7.76471H12.5603L11.9402 5.42494C11.8319 5.01788 11.5821 4.65658 11.2306 4.39842C10.8791 4.14024 10.4461 4.00002 10.0002 4H6.00006ZM32.0009 33.1765C32.0009 33.9253 31.6849 34.6436 31.1223 35.1731C30.5596 35.7026 29.7964 36 29.0008 36C28.2052 36 27.4419 35.7026 26.8793 35.1731C26.3167 34.6436 26.0007 33.9253 26.0007 33.1765C26.0007 32.4277 26.3167 31.7094 26.8793 31.1799C27.4419 30.6504 28.2052 30.3529 29.0008 30.3529C29.7964 30.3529 30.5596 30.6504 31.1223 31.1799C31.6849 31.7094 32.0009 32.4277 32.0009 33.1765ZM13.0003 36C13.7959 36 14.5591 35.7026 15.1217 35.1731C15.6843 34.6436 16.0004 33.9253 16.0004 33.1765C16.0004 32.4277 15.6843 31.7094 15.1217 31.1799C14.5591 30.6504 13.7959 30.3529 13.0003 30.3529C12.2046 30.3529 11.4415 30.6504 10.8789 31.1799C10.3163 31.7094 10.0002 32.4277 10.0002 33.1765C10.0002 33.9253 10.3163 34.6436 10.8789 35.1731C11.4415 35.7026 12.2046 36 13.0003 36Z"
            />
          </svg>
          <span class="items-count" *ngIf="cartItemsCount">{{
            cartItemsCount
          }}</span>
        </a>
        <button
          class="header-navigation--item wallet-btn"
          (click)="signInWithMetamask()"
          [class.connected]="isConnected"
          [class.loading]="loading"
          [attr.title]="publicId || ''"
          [disabled]="loading"
        >
          <span>{{
            isConnected
              ? publicId || "Connecting..."
              : loading
              ? "Connecting..."
              : "Connect Wallet"
          }}</span>
          <span *ngIf="!loading && isConnected" class="metamask-icon"></span>
          <div *ngIf="loading" class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </button>
      </div>
    </div>
    <div class="header-right-bottom">
      <div class="header-stats">
        <div class="header-stats-in red">Tiles Sold: {{ tileStats?.sold }}</div>
        <div class="header-stats-in green">
          Tiles Available: {{ tileStats?.available }}
        </div>
      </div>
    </div>
  </div>
  <div class="toolbox-container">
    <app-toolbox></app-toolbox>
  </div>
</header>
